import { render, staticRenderFns } from "./TextAreaInput.vue?vue&type=template&id=11551581&scoped=true&"
import script from "./TextAreaInput.vue?vue&type=script&lang=ts&"
export * from "./TextAreaInput.vue?vue&type=script&lang=ts&"
import style0 from "./TextAreaInput.vue?vue&type=style&index=0&id=11551581&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11551581",
  null
  
)

export default component.exports